import { gql } from '@apollo/client';

export const ALL_CONTRACTS = gql`
  query GetAllUsers($contractFilter: ContractsFilter) {
    contracts(contractFilter: $contractFilter) {
      name
      evcoId
      site {
        id
        name
      }
      user {
        email
      }
      tenant
      tokens {
        print
        deviceType
        id
      }
      connectors {
        evseId
        name
      }
      billing_method
      address_name
      address_name2
      address_street
      address_city
      address_country
      invoice_address_company
      invoice_address_name
      invoice_address_name2
      invoice_address_street
      invoice_address_city
      invoice_address_country
      lexoffice_customer_id
    }
  }
`;

export const ADD_NEW_CONTRACT = gql`
  mutation createContract($contract: CreateContractInput!) {
    createContract(contract: $contract) {
      name
      evcoId
      tokens {
        id
        deviceType
        print
      }
    }
  }
`;

export const EDIT_CONTRACT = gql`
  mutation updateContracts($contract: UpdateContractInput!, $filter: ContractsFilter!) {
    updateContracts(contract: $contract, filter: $filter)
  }
`;

export const ASSIGN_CONTRACT_TO_CONNECTOR = gql`
  mutation assignContractToConnector($contractConnector: ContractFilter!) {
    assignContractToConnector(Contract_Connector: $contractConnector)
  }
`;

export const REMOVE_CONTRACT_FROM_CONNECTOR = gql`
  mutation removeContractFromConnector($contractConnector: ContractFilter!) {
    removeContractFromConnector(Contract_Connector: $contractConnector)
  }
`;

export const DELETE_CONTRACT = gql`
  mutation deleteContract($filter: ContractFilter!) {
    deleteContract(filter: $filter)
  }
`;

export const GET_CONTRACT_BY_ID = gql`
  query getContractByID($contractFilter: ContractsFilter) {
    contracts(contractFilter: $contractFilter) {
      name
      evcoId
      user {
        id
        email
        fullName
      }
      group {
        group_id
        group_name
      }
    }
  }
`;

export const GET_USERS_CONTRACT = gql`
  query Users($userFilter: UserFilter!) {
    users(userFilter: $userFilter) {
      contracts {
        name
        evcoId
      }
    }
  }
`;

export const GET_CONTRACT_FOR_USER = gql`
  query Contract($contractFilter: ContractsFilter) {
    contracts(contractFilter: $contractFilter) {
      evcoId
      name
    }
  }
`;
